<template>
  <w-flex wrap class="justify-space-between">
    <div class="xs8 headline text-left pl7 monitoring-title">
      <span>
        <!-- otherwise the anchor element would wrap the icon incrrectly -->
        <router-link v-if="from" :to="from" class="back-link">
          <w-icon class="v-middle" fill-height color="primary">
            mdi mdi-arrow-left
          </w-icon>
        </router-link>
      </span>
      <span> Robot's connections hystory </span>
    </div>
    <w-flex wrap class="align-center">
      <span class="center pya">Last Refresh:
        {{
          lastRefresh
            ? timeformatLoc(
              Math.floor(lastRefresh.getTime() / 1000),
              optionsStore.getState().localeBrowser,
              optionsStore.getState().timezoneBrowser
            )
            : lastRefresh
        }}
      </span>
      <w-button class="mx5" lg @click="refresh()">Refresh</w-button></w-flex>
  </w-flex>
  <div class="text-left ma5">

    <div>
      <span class="title2 my2 text-bold">IMEI: {{ robotSessionStore.state.lastConnection.imei }}</span> <br />
      <span class="title3 align-center d-flex my3"
        v-if="robotSessionStore.state.labelList && robotSessionStore.state.labelList.length > 0">
        <span class="text-bold">Label Groups: &nbsp;</span>
        <w-tag class="button pa2 mx2 wrap"
          v-for="(item, index) in robotSessionStore.state.labelList" :key="index" :model-value="item"
          @click="loadLabelGroup(item)" :bg-color="item === robotSessionStore.state.selectedLabel ? 'primary-light2' : 'primary'"
    dark
    lg> {{ item
          }}&nbsp;&nbsp;</w-tag></span><span v-else class="text-bold"> No Label Group assigned </span> <br />
    </div>

    <SessionReport v-if="!loading && robotSessionStore.state.lastConnection.totalElements > 0"
      :item="robotSessionStore.state.lastConnection" :lastRefresh="lastRefresh" />
  </div>
  <div class="mx2 my3">
    <w-table hover fixed-headers :loading="logTable.loading" :headers="logTable.headers" :items="logTable.items">
      <template v-slot:no-data>
        <div v-if="logTable.loading" class="text-center pa3">
          <w-progress-circular indeterminate color="primary" size="64" />
        </div>
        <div v-else class="text-center ">
          <div class="body1 grey--text">
            There are no event to display for this robot.
          </div>
        </div>
      </template>

    </w-table>
  </div>
  <w-flex>
    <w-input inner-icon-right="mdi mdi-close" @click:inner-icon-right="() => clearSearch('baseStationName')" class="mx2"
      v-model.trim="filters['baseStationName']" @input="
        () => delayedSearch(filters['baseStationName'], 'baseStationName')
      ">
      Base Station
    </w-input>
    <w-select class="mx2" v-model="filters['reasonSessionTerminated']" :items="robotSessionStore.getState().reasons"
      inner-icon-right="mdi mdi-arrow-down" inner-icon-left="mdi mdi-close"
      @click:inner-icon-left="(e) => filters['reasonSessionTerminated'] = undefined">
      Reason Session Terminated
    </w-select> </w-flex><!-- table data -->
  <PaginationNav :paginationStore="robotSessionStore"></PaginationNav>
  <div class="mx2">
    <!--table component-->
    <w-table class="robot-session-list" hover fixed-headers :loading="table.loading" :headers="table.headers" :items="table.items">
      <template v-slot:no-data>
        <div v-if="logTable.loading" class="text-center pa5">
          <w-progress-circular indeterminate color="primary" size="64" />
        </div>
        <div v-else class="text-center pa5">
          <w-icon size="64" color="grey--text">mdi mdi-playlist-remove</w-icon>
          <div class="title3 grey--text my3">
            No connections found
          </div>
          <div class="body1 grey--text">
            There are no connection to display for this robot in the last 30 days
          </div>
        </div>
      </template>
      <template v-slot:[`item-cell.session`]="{ item }">
        <table class="title4 my2">
          <tr v-for="row in historyCard({
            start: item.sessionStart,
            stop: item.sessionStop,
          }).rows" :key="row.label">
            <td class="text-bold" v-if="row.date">
              {{ row.label }}: &nbsp;&nbsp;
            </td>
            <td v-if="row.date">{{ row.date }} &nbsp;&nbsp;</td>
            <td>
              {{ row.time }}
            </td>
          </tr>
        </table>
      </template>
      <template v-slot:[`item-cell.duration`]="{ item }">
        <span v-if="item.sessionStop" class="ml2">
          {{ getTime(item.sessionStop - item.sessionStart) }}
        </span>
        <span v-else class="ml2"> {{ getTime(now - item.sessionStart) }} </span>
      </template>
      <template v-slot:[`item-cell.totalBytes`]="{ label }">
        {{ formatBytes(label) }}
      </template>
      <template v-slot:[`item-cell.baseStationSession`]="{ label }">
        <w-flex>
          <table class="title4">
            <tr v-for="row in historyCard({
              start: label.lastConnectionStart,
              stop: label.lastConnectionStop,
            }).rows" :key="row.label">
              <td class="text-bold" v-if="row.date">
                {{ row.label }}: &nbsp;&nbsp;
              </td>
              <td v-if="row.date">{{ row.date }} &nbsp;&nbsp;</td>
              <td>
                {{ row.time }}
              </td>
            </tr>
          </table>
        </w-flex>
      </template>
      <template v-slot:[`item-cell.baseStationSessionDuration`]="{ item }">
        <div v-if="item.baseStationSession.lastConnectionStart">
          <span v-if="item.baseStationSession.lastConnectionStop" class="ml2">
            {{
              getTime(
                item.baseStationSession.lastConnectionStop -
                item.baseStationSession.lastConnectionStart
              )
            }}
          </span>
          <span v-else class="ml2">
            {{ getTime(now - item.baseStationSession.lastConnectionStart) }}
          </span>
        </div>
      </template>
      <template v-slot:[`item-cell.throughput`]="{ item }">
        <span v-if="item.totalBytes"> {{ formatBytesPerSecond(
          item.totalBytes / ((item.sessionStop ? item.sessionStop : lastRefresh.getTime() / 1000) - item.sessionStart)
        ) }}</span>
      </template>
    </w-table>
  </div>
  <PaginationNav :paginationStore="robotSessionStore"></PaginationNav>
</template>
<script>

import { robotSessionStore } from "../store/robot-sessions";
import {
  timeformatLoc,
  timeformatt,
  dateformatt,
  getTime,
} from "@/utils/time-formatter";
import { optionsStore } from "@/store/options";
import {
  ref,
  reactive,
  onMounted,
  watch,
} from "vue";
import { useRoute } from "vue-router";
import PaginationNav from "../components/PaginationNav.vue";
import SessionReport from "../components/SessionReport.vue";
import { formatBytesPerSecond, formatBytes } from "@/utils/unit-formatter";
import { groupStore } from '@/modules/label-group/store/label-group';
import router from "@/router";
import { errorStore } from "@/modules/errors/store/errors";
export default {
  components: { PaginationNav, SessionReport },

  setup: () => {
    const now = ref(new Date().getTime() / 1000);
    var lastRefresh = ref(new Date());
    const isMounted = ref(false);
    const loading = ref(true);
    const delayed = reactive({
      timer: 0,
      function: null,
      ms: 500,
    });
    var from = ref("");
    const filters = reactive({});
    const table = reactive({
      headers: [
        { label: "Base Station", key: "baseStationName", sortable: false },
        { label: "Session ", key: "session", sortable: false },
        { label: "Time Span ", key: "duration", sortable: false },
        {
          label: "Reason Session Terminated",
          key: "reasonSessionTerminated",
          sortable: false,
        },
        { label: "Total Bytes", key: "totalBytes", sortable: false },
        { label: "Throughput NTRIP", key: "throughput", sortable: false },
        {
          label: "Base Station Session",
          key: "baseStationSession",
          sortable: false,
        },
        {
          label: "Time Span",
          key: "baseStationSessionDuration",
          sortable: false,
        },
      ],
      items: [],
    });

    const logTable = reactive({
      headers: [
        { label: "Event Time", key: "logTime", sortable: false },
        { label: "Message", key: "message", sortable: false },
      ],
      items: [],
      loading: false,
    });

    function historyCard(item) {
      return {
        headers: [
          { label: "label", key: "label" },
          { label: "date", key: "date" },
          { label: "time", key: "time" },
        ],
        rows: [
          {
            label: "End",
            date: dateformatt(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            time: timeformatt(
              item.stop,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
          },
          {
            label: "Start",
            date: dateformatt(
              item.start,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
            time: timeformatt(
              item.start,
              optionsStore.getState().locale,
              optionsStore.getState().timezone
            ),
          },
        ],
      };
    }
    async function refresh() {
      table.loading = true;
      loading.value = true;
      const response = await robotSessionStore.loadData(
        robotSessionStore.paginationParams,
        await robotSessionStore.getState().call
      );
      if (response) {
        robotSessionStore.state.data = response;
        table.loading = true;
      }
      const report = robotSessionStore.refreshLastConnection();
      if (report) {
        now.value = new Date().getTime() / 1000;
        loading.value = false;
        lastRefresh.value = new Date();
      }
      await robotSessionStore.loadSystemOperations()
        console.log("loadSystemOperations done");
        logTable.loading = true;
        logTable.items = robotSessionStore.state.logs;
        logTable.loading = false;
    }
    async function mount() {
      // router system must be changed to retrive path variables
      // robotSessionStore.closeStore();
      errorStore.clean()
      const route = useRoute();
      console.log("mount ", route.query);
      console.log(route.query.from);
      from.value = route.query.from;
      console.log(route.query.basestation);
      route.query.basestation ? filters["baseStationName"] = route.query.basestation : null;
      await robotSessionStore.initPagination();
      robotSessionStore.setImei(route.params.robotImei);
      if (robotSessionStore.getIsInitialized()) {
        console.log("is inizialized");
        // robotSessionStore.setPagination({ currentPage: -1 });
        robotSessionStore.setImei(route.params.robotImei);
        route.query.basestation
          ? robotSessionStore.setFilter(
            "baseStationName",
            route.query.basestation
          )
          : null;
        refresh();
        // robotSessionStore.updateDetails()  
        isMounted.value = true;
      }
    }

    function clearSearch() {
      filters['baseStationName'] = null
      robotSessionStore.setFilter("baseStationName", "");
    }

    function delayedSearch(target, name) {
      clearTimeout(delayed.timer);
      delayed.timer = 0;
      delayed.function = function () {
        target ? (target = target.trim()) : null;
        robotSessionStore.setFilter(name, target);
      };
      delayed.ms = 800;
      clearTimeout(delayed.timer);
      delay(target);
    }
    function delay(...args) {
      delayed.timer = setTimeout(delayed.function.bind(...args), delayed.ms);
    }

    async function loadLabelGroup(label) {
      groupStore.state.label = label;
      groupStore.getImeiByLabel(label).then(()=>{
        console.log("complete as "+ groupStore.imei);
        router.push("/label-group");})
    }

    onMounted(() => mount());
    watch(
      () => robotSessionStore.state.data,
      (data) => {
        table.loading = true;
        table.items = data;
        table.loading = false;
      }
    );

    watch(
      () => robotSessionStore.state.logs,
      (logs) => {
        logTable.loading = true;
        logTable.items = logs;
        logTable.loading = false;
      }
    );

    watch(
      () => filters["reasonSessionTerminated"],

      (newFil, oldFil) => {
        if (newFil != oldFil) {
          robotSessionStore.setFilter(
            "reasonSessionTerminated",
            newFil
          );
        }
      }
    );

    watch(() => robotSessionStore.pagination, async (anyPaginationChange) => {
      console.log("WATCH pag", loading.value == false, anyPaginationChange.currentPage == 0);
      if (loading.value == false && anyPaginationChange.currentPage == 0) {
        const report = await robotSessionStore.refreshLastConnection();

        console.log("WATCH sendreport");
        if (report) {

          console.log("WATCH update");
          now.value = new Date().getTime() / 1000;
          loading.value = false;
          lastRefresh.value = new Date();
        }
      }
    }, { deep: true })

    return {
      from,
      now,
      loading,
      filters,
      historyCard,
      timeformatLoc,
      getTime,
      lastRefresh,
      delayedSearch,
      table,
      logTable,
      optionsStore,
      robotSessionStore,
      refresh,
      clearSearch,
      formatBytesPerSecond,
      formatBytes,
      loadLabelGroup
    };
  },
};
</script>
<style scoped>
.monitoring-title {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
}

.back-link {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.v-middle {
  vertical-align: middle;
}

.robot-session-list {
  font-family: "Roboto", monospace;
  max-height: 60%;
  letter-spacing: -0.5px;
}
</style>
